import { render, staticRenderFns } from "./StatusBtn.vue?vue&type=template&id=3fac8b88&scoped=true&"
import script from "./StatusBtn.vue?vue&type=script&lang=js&"
export * from "./StatusBtn.vue?vue&type=script&lang=js&"
import style0 from "./StatusBtn.vue?vue&type=style&index=0&id=3fac8b88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fac8b88",
  null
  
)

export default component.exports